var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWaveformDuotone = function SvgWaveformDuotone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-waveform-duotone",
    clipPath: "url(#clip0_1150_2062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.3106 0.333336V13.6667H46.263L33.3106 0.333336ZM36.5487 27H31.5742L29.006 21.7167C28.5791 20.8377 27.7755 20.2875 26.7323 20.3365C25.7772 20.3755 24.9331 20.9907 24.5789 21.9052L20.1154 33.4063L17.6767 28.3854C17.2618 27.5313 16.422 27 15.41 27H2.54874C1.65462 27 0.929688 27.75 0.929688 28.6667V30.3333C0.929688 31.2538 1.65462 32 2.54874 32H14.0035L18.1908 40.6167C18.5975 41.4688 19.4374 42 20.3583 42C20.3899 42 20.4247 42 20.4595 41.9967C21.4145 41.9577 22.2586 41.3425 22.6128 40.428L27.0814 28.928L27.9004 30.6145C28.3118 31.4688 29.1517 32 30.0725 32H36.5487C37.4429 32 38.1678 31.2538 38.1678 30.3333V28.6667C38.1678 27.75 37.4392 27 36.5487 27Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M46.2634 13.6667V48.6667C46.2634 51.4281 44.0888 53.6667 41.4063 53.6667H12.2634C9.58083 53.6667 7.40625 51.4271 7.40625 48.6667V32H13.9998L18.1871 40.6167C18.5979 41.4688 19.4378 42 20.3586 42C20.3903 42 20.425 42 20.4598 41.9967C21.4149 41.9577 22.259 41.3425 22.6132 40.428L27.0817 28.928L27.9008 30.6145C28.3122 31.4688 29.1521 32 30.0729 32H36.5491C37.4432 32 38.1682 31.2538 38.1682 30.3333V28.6667C38.1682 27.75 37.4396 27 36.5491 27H31.5746L29.0064 21.7167C28.5795 20.8377 27.7759 20.2875 26.7326 20.3365C25.7776 20.3755 24.9335 20.9907 24.5793 21.9052L20.1158 33.4063L17.6771 28.3854C17.2622 27.5313 16.4223 27 15.4104 27H7.40625V5.33334C7.40625 2.57188 9.58083 0.333336 12.2634 0.333336H33.311V13.6667H46.2634Z",
    fill: "#DADADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1150_2062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.3333,
    height: 53.3333,
    fill: "white",
    transform: "translate(0.929688 0.333336)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaveformDuotone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waveform-duotone.1153d7a3.svg";
export { ForwardRef as ReactComponent };